import React from 'react';
import { Badge, Skeleton, Text } from '@/components/ui';

interface CountCellProps {
  value?: unknown;
  render?: () => React.ReactNode;
}

function CountCell({ value, render }: CountCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  if (value === null || value === undefined) {
    return (
      <Text size="2" color="gray" className="data-cell__count">
        —
      </Text>
    );
  }

  const count = typeof value === 'number' ? value : Number(value);
  
  if (isNaN(count)) {
    return (
      <Text size="2" color="gray" className="data-cell__count">
        —
      </Text>
    );
  }

  // Format large numbers with locale string
  const displayValue = count.toLocaleString();

  return (
    <Badge
      size="xsmall"
      color="default"
      variant="surface"
      highContrast
      className="data-cell__count"
    >
      {displayValue}
    </Badge>
  );
}

export function CountCellSkeleton() {
  return (
    <Skeleton style={{ width: '60px', height: '20px', borderRadius: '4px' }} />
  );
}

export default CountCell;

